import { addNavbarNotification } from "./navbarNotifications";

/** Apply notification payloads returned from onboarding API responses. */
export function applyOnboardingNotifications(notifications = []) {
  if (!Array.isArray(notifications) || notifications.length === 0) return;
  notifications.forEach((item) => {
    if (!item?.title && !item?.message) return;
    addNavbarNotification({
      userId: item.userId ?? null,
      targetRoles: item.targetRoles ?? null,
      title: item.title,
      message: item.message,
      type: item.type || "onboarding",
    });
  });
}
